import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { compose } from 'redux';
import { TravelCompanyList } from './TravelCompanyList';
import { TravelCompanyCreate } from './TravelCompanyCreate';
import { TravelCompanySettings } from 'containers/TravelCompanies/TravelCompanySettings';
import AuthRoute from 'containers/AuthRoute';
import { EUserType } from 'services/BackendApi';
import { useDynamicParameters } from 'context/DynamicParameters/DynamicParametersContext';
import { TravelCompanySettingsV2 } from './TravelCompanySettings/TravelCompanySettingsV2';

export interface TravelCompaniesRoutingProps extends RouteComponentProps {}

export const TravelCompaniesRoutingComponent = (props: TravelCompaniesRoutingProps) => {
  const { dynamicParameters } = useDynamicParameters();
  return (
    <Switch>
      <>
        <Route
          path={`${props.match.path}/:companyUuid/settings`} 
          component={dynamicParameters.ENABLE_CRM_WORKSPACE_TEMP ? TravelCompanySettingsV2 : TravelCompanySettings}
        />
        <AuthRoute
          allow={[EUserType.ADMIN]}
          path={`${props.match.path}/`}
          component={TravelCompanyList}
          exact
        />
        <AuthRoute
          allow={[EUserType.ADMIN]}
          path={`${props.match.path}/create`}
          component={TravelCompanyCreate}
        />
      </>
    </Switch>
  );
};

export const TravelCompaniesRouting = compose(withRouter)(TravelCompaniesRoutingComponent);
